const openButtons = document.querySelectorAll('.open-search');
const searchBox = document.querySelector('.nosto-header-search');

if (openButtons.length > 0 && searchBox) {
    openButtons.forEach(function(btn) {
        btn.addEventListener('click', function() {
            searchBox.classList.add('active');
            document.body.classList.add('overflow-hidden');
        });
    });

    const closeBtn = document.querySelector('.nosto-header-search__close');
    if (closeBtn) {
        closeBtn.addEventListener('click', function() {
            searchBox.classList.remove('active');
            document.body.classList.remove('overflow-hidden');
        });
    }
}